<template>
  <div>
    <div class="container" v-if="vista">
      <div class="anterior">
        <arrow-left />
      </div>
      <div class="adelante">
        <sales-button
          class="button"
          :label="nombreSiguiente"
          :loading="disabled"
          :analyticsName="analyticsName"
          @click="adelante"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SalesButton from "@/components/core/SalesButton";
import ArrowLeft from "@/components/core/ArrowLeft";
import get from "lodash/get";

export default {
  name: "StepNavigator",
  components: { SalesButton, ArrowLeft },
  props: {
    value: Object,
    storeAction: String,
    routerPush: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    analyticsName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      vista: null
    };
  },
  methods: {
    adelante() {
      if (this.storeAction) {
        this.$store.dispatch(this.storeAction, this.value);
      }
      if (this.routerPush) {
        const route = get(
          this.config.pasos,
          "[" + get(this.vista, "config.pasoSiguiente", "false") + "].path",
          null
        );
        if (route) {
          this.$router.push(route).catch(() => {});
        }
      }
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  },
  computed: {
    nombreSiguiente() {
      return this.vista.config.nombreSiguiente || "Continuar";
    }
  }
};
</script>

<style scoped>
div.container {
  margin-top: 20px;
  padding-bottom: 80px;
  display: flex;
  justify-content: space-between;
  height: 56px;
}

p {
  margin-left: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #237aba;
}

div.adelante .button {
  height: auto;
  padding: 0;
  margin: 0;
}

/* Para dar vuelta los botones */
@media screen and (min-width: 600px) {
  div.container {
    flex-direction: column;
    /* Fix botón que desaparece */
    padding-bottom: 0;
    height: auto;
    min-height: 1px;
  }

  div.anterior {
    order: 2;
  }

  div.adelante {
    width: 212px;
    margin-bottom: 27px;
  }
}
</style>
